<template>
<div class="text-center container " id="circleStartDiv">

<v-card width="60%" class="mx-auto m4u_tertiary " >

        <v-card flat>
          <!--- START OF THE CIRCLE SECTION!!! --->
            <div class="circleMain">

    <div class="container circleList m4u_tertiary" >
  <!--- START NEW CIRCLE DIALOG --->
    <!-- <v-row justify="center"> -->

      <v-dialog
      v-model="dialog"
      persistent
      :max-width ="$vuetify.breakpoint.xs ? '70vw' : '30vw'"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary mb-5"
          dark
          v-bind="attrs"
          v-on="on"
          class="newCircleBtn m4u_text--text"
        >
        New Circle
        <v-icon>mdi-plus-box</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="headline m4u_text--text">New Circle</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
              >
                <v-text-field
                  label="Circle name*"
                  required
                  color="m4u_text"
                  v-model="newCircleName"
                  :rules="nameRules"
                ></v-text-field>
              </v-col>

            </v-row>
          </v-container>
          <small class="m4u_text--text" v-if="everyoneCheck">You cannot have 2 circles named Everyone</small>
          <small class="m4u_text--text">*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="teal--text text--accent-4"
            text
            @click="closeEditBox()"
          >
            Close
          </v-btn>
          <v-btn
            class="teal--text text--accent-4"
            text
            @click="newCircle(newCircleName, user.UserID)"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- </v-row> -->

    <!--- START CIRCLE LIST --->

      <v-row justify="center">
        <div v-for="circle in circles"  :key="circle.CircleID" >

      <!---EACH CIRCLE WILL BE CREATED HERE --->
          <div class="circleDiv m4u_text--text primary" v-if="circle.CircleName !=='Journal' && (deletecircledialog === false || (deletecircledialog && circle.CircleID === circleID))" >
             {{circle.CircleName}} <BR/>

<!--- NEW EDIT DIALOG WITH FULL EDIT DIV INSIDE --->
 <v-dialog
      v-model="fulleditdialog"
      fullscreen
      persistent
      hide-overlay
      transition="dialog-bottom-transition"
      :retain-focus="false"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          icon
          v-bind="attrs"
          v-on="on"
          @click="openCircle(circle.CircleID, circle.CircleName, circle.CirclePrimary)"
        >
            <v-icon class="m4u_text--text">mdi-pencil-outline</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-toolbar
          dark
          color="primary"
        >

          <v-toolbar-title class="m4u_text--text">Edit Circle</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
        <v-btn
            icon
            dark
            @click="fulleditdialog = false"
            class="teal--text text--accent-4"
          >
            Close
          </v-btn>
            <v-btn
              dark
              class="teal--text text--accent-4"
              text
              @click="updateCircle(circleID, circleName)"
            >
              Save
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <div v-if="fulleditdialog" class="outerDiv">
<!---          <form @submit.prevent> --->
 
            <div >
  <!--- STARTING NON-EVERYONE CIRCLE EDIT --->
      <div v-if="!usingEveryone" class="mx-5">

      <v-text-field
      color="m4u_text"
       label="Circle Name"
       v-model="circleName" 
       :rules="nameRules"
      
      />
      </div>


<!-- Beginning of Member List -->
  <v-card
    class="mx-auto"
    max-width="300"
    tile
    @click:outside="this.$emit('input', false)"
  >
    <v-list dense>
      <v-card-text v-if="usingEveryone"> 
        <v-btn @click="showForm = true" v-if="showForm === false" class="m4u_text--text">Add Other Members</v-btn>

        
      </v-card-text>
       <v-card-text v-if="!usingEveryone" class="m4u_text--text">Select from Your Everyone Circle </v-card-text>
       <!-- START ADD MEMBERS LIST  -->                



      <v-card v-if="usingEveryone === true  && showForm === true">

        <v-card-text >
          <v-container >
            <v-row >
              <v-btn-toggle
          v-model="toggle_exclusive"
          mandatory
        >
          <v-btn class="sm m4u_text--text" primary @click="setSearchByEmail()" >
            <v-icon class="m4u_text--text">mdi-magnify</v-icon>
            Email
          </v-btn>
          <v-btn class="sm m4u_text--text" primary @click="setSearchByName()" >
            <v-icon class="m4u_text--text">mdi-magnify</v-icon>
            Name
          </v-btn>

        <v-btn @click="showForm = false" icon >
          <v-icon class="m4u_text--text">mdi-close</v-icon>
          </v-btn>
        </v-btn-toggle>


            </v-row>
            <!--Starting search form here --->
            <div>
<v-form v-model="searchNameValid" v-if="searchby === 'name'">
    <v-container>
      <v-row>
    <v-row class="mt-10">
      <h3 class="m4u_text--text">{{nameErr}}</h3>
      </v-row>
        <v-col
          cols="12"
          
        >
          <v-text-field
            v-model="firstname"
            :counter="75"
            label="First name"
            color="m4u_text"
            
          ></v-text-field>
        </v-col>

        <v-col
          cols="12"
          v-if="searchby === 'name'"
        >
          <v-text-field
            v-model="lastname"
            :counter="75"
            label="Last name"
            color="m4u_text"
          
          ></v-text-field>
        </v-col>
      </v-row>
              <v-btn
            color="primary"
            class="m4u_text--text"
            text
            @click="search()"
          >
            Search
          </v-btn>
    </v-container>
  </v-form>

<v-form v-model="searchEmailValid"  v-if="searchby === 'email'" >
    <v-container>
      <v-row class="mt-10">
      <h3>{{nameErr}}</h3>
      </v-row>
      <v-row>
        <v-col
          cols="12"
        >
          <v-text-field
            v-model="email"
            :rules="searchEmailRules"
            label="E-mail"
            required
            color="m4u_text"
          ></v-text-field>
        </v-col>
      </v-row>
        <v-btn
            color="primary"
            class="m4u_text--text"
            text
            @click="search()"
          >
            Search
          </v-btn>
    </v-container>
  </v-form>
            </div>
        <!--- END OF search form here --->
        <div v-if="searchResult">
<div v-for="result in searchResult" :key="result.UserID">

    <v-checkbox
      v-model="selected"
      :label="result.UserDisplayName"
      :value="result.UserID"
      class="m4u_text--text"
    ></v-checkbox>
  
</div>
</div>
          </v-container>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
           v-if="searchResult"
            class="teal--text text--accent-4"
            text
            @click="addToEveryone"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>

        
        <!-- END ADD MEMBERS LIST -->

        <v-list-item
          v-for="member in members"
          :key="member.MemberID"
        >
  
              <v-checkbox
              class="m4u_text--text"
              v-if="usingEveryone===false"
                v-model="member.inorout"
                :value="member.inorout"
                @click="changeStatus(member.MemberID, member.inorout)"
              ></v-checkbox>

          <v-list-item-content>
            <v-list-item-title title="Invitation Not Yet Accepted" primary v-text="member.UserDisplayName" 
            class="m4u_text--text" v-if="member.CircleStatus === 0" >
            </v-list-item-title>
            <v-list-item-title title = "Invitation Accepted" v-text="member.UserDisplayName" class="m4u_text--text invitationStatus"
            v-if="member.CircleStatus === 1" link @click="goToProfile(member.MemberID)"  >

            </v-list-item-title>
            <span v-if="member.CircleStatus === 1" class="m4u_text--text invitationStatus">Accepted</span>
            <span v-if="member.CircleStatus === 0" class="m4u_text--text invitationStatus">Open</span>
          </v-list-item-content>
          <v-list-item-icon>
        <v-btn
        @click="everyonedialog = !everyonedialog"
        v-if="usingEveryone===true"
          >
     <v-icon class="m4u_text--text">mdi-trash-can-outline</v-icon>
    </v-btn>

    <v-dialog
      v-model="everyonedialog"
      fullscreen
      persistent
      max-width="290"
    >
      <v-card>
      
          <h2 class="m4u_text--text">Deleting an Everyone Circle Member is Permanent!</h2>
        <v-card-text>
          <h4 class="m4u_text--text">Deleting a member from the Everyone circle cannot be undone and will remove that member from <span class="warningtext">all of your circles.</span> </h4>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>


          <v-btn
            color="red darken-1"
            text
            @click="everyonedialog = false"
          >
            Cancel
          </v-btn>

          <v-btn
            color="green darken-1"
            text
            @click="deleteEveryoneMember(member.MemberID, member.CircleID, user.UserID) "
          >
           I Agree
          </v-btn>


        </v-card-actions>
      </v-card>
    </v-dialog>
          </v-list-item-icon>
        </v-list-item>

    </v-list>
  </v-card>
      <!-- End of Member List -->
      </div>
  
<!---         </form>   --->
        </div>
      </v-card>
    </v-dialog>

<!--- END OF EDIT DIALOG WITH FULL EDIT DIV INSIDE --->
              <v-btn
                  v-if="circle.CirclePrimary !== user.UserID "
                  text-color="primary"
                  icon
                @click="deleteCircle(circle.CircleID, user.UserID)"
                  >
            <v-icon class="m4u_text--text">mdi-trash-can-outline</v-icon>
            </v-btn>
          </div>

          <!-- DIV FOR DELETE WARNING -->
        <div v-if="deletecircledialog && circle.CircleID === circleID">

      <v-card>
          <h2 class="m4u_text--text">Are you sure you want to delete your {{circle.CircleName}} circle?</h2>
        <v-card-text>
          
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            text
            @click="deletecircledialog = false"
          >
            Cancel
          </v-btn>

          <v-btn
            color="green darken-1"
            text
            @click="deleteCircle2(circle.CircleID, user.UserID) "
          >
           I Agree
          </v-btn>


        </v-card-actions>
      </v-card>

        </div>

        <!-- ENDING DIALOG FOR DELETE CIRCLE CONFIRMATION -->




      </div>
     </v-row>
    </div>
    <div>
    </div>
          </div>
          <!--- END OF THE CIRCLE SECTION!!! --->
        </v-card>


            <v-divider></v-divider>


        <v-card 
          class="pa-2 mb-3 m4u_tertiary"
          outlined
          tile
          v-if="rinvitations.length > 0"
        >
        <v-card-title class="m4u_text--text">Invitations Received</v-card-title>
        <div v-for= "rinvitation in rinvitations" :rinvitations="rinvitations" :key = "rinvitation.circeleMemID" class="m4u_text--text" >

         From: {{rinvitation.UserDisplayName}}
         <div class="invitationBtn">
           <v-row class="invitationActionRow">
           <v-btn class="primary m4u_text--text"  @click="acceptInvitation(rinvitation.CircleMemID)" small>Accept</v-btn>
           <v-spacer></v-spacer>
           <v-btn class="primary m4u_text--text" @click="declineInvitation(rinvitation.CircleMemID)" small >Decline</v-btn>
           </v-row>
         </div>
         </div>
        </v-card>

     
        <v-card 
          class="pa-2  mb-3 m4u_light_grey"
          outlined
          tile
          v-if="sinvitations.length > 0"
        >
        <v-card-title class="m4u_text--text"> Invitations Sent</v-card-title>
        <div v-for= "sinvitation in sinvitations" :sinvitations="sinvitations" :key = "sinvitation.invitedEmail">
        <v-card-subtitle class="m4u_text--text">
         {{sinvitation.invitedEmail}} <span v-if="sinvitation.ConverDate !== null"></span> 
          <span v-if="sinvitation.ConvertDate"> - Accepted</span>
          <span v-if="!sinvitation.ConvertDate"> - Open</span>
          <hr />
        </v-card-subtitle>
         
        </div>
        </v-card>

            <v-card 
          class="pa-2  mb-3 m4u_text--text"
          outlined
          tile
          v-if="sinvitations.length < 1 && rinvitations.length < 1"
        >
        No invitations received or sent
            </v-card>

  </v-card>


 </div>

</template>
<script>
import EventService from '@/services/EventService.js'; 

export default {

data() {
    return {
      tab: null,
      circles: [],
      circleName: '',
      newCircleName: '',
      originalName: '',
      circleID: '',
      forceKey: 0,
      dialog: false,
      dialog2: false,
      editFlag: false,
      valid: false,
      nameRules: [
        v => !!v || 'A Circle Name is required',
        v => v.length <= 15 || 'Circle Name must be less than 15 characters'
      ],
      searchNameRules: [
        v => v.length <= 75 || 'Name must be less than 75 characters'
      ],
      members: [],
      memberID: '',
      newmembers: [],
      selected: [],
      everyoneCheck: false,
      everyoneincluded: false,
      everyonedialog: false,
      deletecircledialog: false,
      usingEveryone: false,
      toggle_exclusive: undefined,
      searchby: 'email',
      searchEmailValid: false,
      searchNameValid: false,
      firstname: '',
      lastname: '',
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid',
      ],
      searchEmailRules: [
        v => /.+@.+/.test(v) || 'E-mail must be valid',
      ],
      searchResult: [],
      readyToSave: false,
      readyToSearch: true,
      rinvitations: [],
      sinvitations: [],
      showForm: false,
      fulleditdialog: false,
      searchComplete: false,
      nameErr: ''
       }
    },


  mounted() {
    this.getMyCircles(this.user.UserID);
    this.myOpenInvitations();
    this.mySentInvitations();
  },

computed: {
  user(){
    return this.$store.state.user
  },

  loginState(){
    return this.$store.state.loginState
  },

  },


  methods: {
    async getMyCircles() {
      await EventService.getMyCircles(this.user.UserID)
      .then(
        (circles => {
          this.$set(this, "circles", circles);
        }).bind(this)

      );
    },

    async myOpenInvitations() {
      await EventService.myOpenInvitations(this.user.UserID)
      .then(
        (rinvitations => {
          this.$set(this, "rinvitations", rinvitations);
        }).bind(this)
      )
      .then (
        this.$nextTick(()=>{})
      );
    },

    async mySentInvitations() {
      await EventService.mySentInvitations(this.user.UserID)
      .then(
        (sinvitations => {
          this.$set(this, "sinvitations", sinvitations);
        }).bind(this)
      );
    },

    async acceptInvitation(circleMemID) {
      await EventService.acceptInvitation(this.user.UserID, circleMemID)
      .then(
        res => {
        })
        .then(async () => {
       await this.myOpenInvitations()
        }
 )      
    },

    async declineInvitation(circleMemID) {
      await EventService.declineInvitation(this.user.UserID, circleMemID)
      .then(
        res => {
        })
        .then(async () => {
       await this.myOpenInvitations()
        }
 )      
    },

      async openCircle(circleID, circleName, circlePrimary) {
       this.editFlag = true;
       if (this.user.UserID === circlePrimary) {
         this.usingEveryone = true;
       } else {
         this.usingEveryone = false;
       }
        this.originalName = circleName;
        this.circleName = circleName;
        this.circleID = circleID;
        await EventService.getCirclePickList(this.circleID, this.user.UserID)
      .then(
        (members => {
          this.$set(this, "members", members);
        }).bind(this)

      );
    },

      async newCircle(newCircleName, userID) {
        if(!newCircleName) {
          return
        }
        this.dialog = false;
        if(newCircleName === "Everyone" || newCircleName === "everyone") {
          this.everyoneCheck = true
          await this.getMyCircles();
          this.editFlag = false;
          this.deletecircledialog = false;
          return
        } else {
          this.everyoneCheck === false
        
        await (EventService.newCircle(this.newCircleName, userID))
        
        .then( async () => {
          await this.getMyCircles();
          this.newCircleName = '';
          this.editFlag = false;
          this.deletecircledialog = false;
        })
        }

    },
    
    async changeStatus(memberID, inorout) {
      if(inorout === true) {
      await (EventService.addCircleMember(memberID, this.circleID, this.user.UserID))
      } else {
      await (EventService.deleteCircleMember(memberID, this.circleID))
      }
    },

    async setSearchByEmail() {
      this.toggle_exclusive = 1
      this.searchby = 'email';
      this.email = ''
      this.nameErr = ''
    },

    async setSearchByName() {
      this.toggle_exclusive = 0
      this.nameErr = ''
      this.searchby = 'name'
      this.firstname = '';
      this.lastname = '';
    },

    async readyToClose() {
      this.myOpenInvitations();
      this.mySentInvitations();
      this.dialog2 = false,
      this.searchResult = []
      this.readyToSave = false,
      this.readyToSearch = true
    },


      async search() {
        if (this.searchby === 'name' && this.firstname.length === 0) {
          this.nameErr = "First and Last Name Required"
          return
        }
        if (this.searchby === 'name' && this.lastname.length === 0) {
          this.nameErr = "Last and Last Name Required"
          return
        }
        if (this.searchby === 'email' && this.email.length === 0) {
          this.nameErr = "Email Address Required"
          return
        }
        await (EventService.searchToAddToEveryone(this.user.UserID, this.firstname, this.lastname, this.email, this.searchby))
       .then (
          (searchResult => {
          this.$set(this, "searchResult", searchResult);
          if(searchResult.length > 0) {
          this.readyToSave = true
          this.readyToSearch = false
          } else {
            this.nameErr = 'Not found'
          }

        }).bind(this) 
       )
    },

          async addToEveryone() {
      this.dialog2 = false,
        await (EventService.addToEveryone(this.user.UserID, this.selected))
        .then( () => {
          this.selected = []
        })
        .then( () => {
          this.dialog = false
          this.dialog2 = false
          this.editFlag = false;
          this.firstname = '';
          this.lastname = '';
          this.email = '';
          this.showForm = false;
          this.fulleditdialog = false;
        })
        .then(() => {
          this.mySentInvitations();
          this.myOpenInvitations();
        })
    },

      async deleteCircle(circleID, userID) {
        this.deletecircledialog = true
        this.circleID = circleID
    },
      async deleteCircle2(circleID, userID) {
        this.circledeletedialog = false
        this.circleID = null
        await (EventService.deleteCircle(circleID, userID))
        .then(
        (circles => {
          this.$set(this, "circles", circles);
        }).bind(this)
        )
        .then( async () => {
          await this.getMyCircles();
          this.editFlag = false;
          this.deletecircledialog = false;
        })

    },

      async updateCircle(circleID, circleName) {
        await (EventService.updateCircle(circleID, circleName))
        .then( () => {
          this.getMyCircles();
          this.fulleditdialog = false;
        })

    },

    closeEditBox() {
      this.circleName = '';
      this.dialog = false;
    },

      async getPickList(circleID, circlePrimary) {

       if (circlePrimary === this.user.UserID) {
         this.usingEveryone = true;
       }
       else
       {
         this.usingEveryone = false;
       await (EventService.getEveryoneMembersToAdd(this.user.UserID, circleID))
      .then(
        (newmembers => {
          this.selected = []
          this.$set(this, "newmembers", newmembers);
            if (this.newmembers.length === 0) {
              this.everyoneincluded = true
            } else {
              this.everyoneincluded = false
            }
        }).bind(this)

      );
       }
    },

     async deleteEveryoneMember(memberID, circleID, userID) {
       this.everyonedialog = false
      await (EventService.deleteEveryoneCircleMember(memberID, userID))
      .then (
        () => (EventService.getCircleMembersAll(circleID)
            ) 
      .then(
        (members => {
          this.$set(this, "members", members);
          this.fulleditdialog = false;
        }).bind(this)
      )

      )
    },


      async addCircleMember(selectedmembers, circleID) {
        this.dialog2 = false
           await (this.insertNewMembers(selectedmembers, circleID))
       .then (
        () => (EventService.getCircleMembersAll(circleID)
          )
       )  
       .then (
          (members => {
          this.$set(this, "members", members);
        }).bind(this) 
       )
    },

    async insertNewMembers(selectedmembers, circleID) {
      await selectedmembers.forEach(async function(memberID) {
      await EventService.addCircleMember(memberID, circleID) 
          })
    },

      async closeEdit(circleID, originalName) {
        EventService.updateCircle(circleID, originalName)
        this.getMyCircles(this.user.UserID);
        this.editFlag = false;


    },

    async goToProfile(memberID) {
      this.$router.push({ name: 'profile', params: {'profileID': memberID} })
    }
  }
};

</script>
<style lang="scss" scoped>

  .circleButton {
    overflow: hidden;
    height: auto;
      width: auto;
  }
  .circleDiv {
  border: solid;
  border-width: 3px;
  border-color: #250E62;
  background-color: white;
  padding: 20px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  max-height: 80%;
  margin: 4px 4px;
  border-radius: 50%;
 
  
  }

  .circleDiv:hover a {
    background-color: #000;
  }

  .circleList {
    max-height: 20%;
    scroll-behavior: auto;
  }

  .circleMain {
    margin-top: 1em;
  }

  .formCard {
    max-width: 80%;
    justify-content: center;
  }

  .invitationActionRow {
    margin: 3px;
  }

  .invitationMain {
    margin-top: 1em;
  }

  .invitationBtn {
    display: inline-block;
  }

  .invitetoJoinButton {
    margin: 3px; 

  }

  .invitationStatus {
    font-size: .75rem
  }

  .newCircleBtn {
    margin-bottom: 5px;
    margin-top: 7px;
  }

  .outerDiv {
    background-color: white;
    cursor: pointer;
  }

 .warningtext {
   font-size: 1.25em;
 }
</style>